import React from 'react';
import ReactDOM from 'react-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ActivateConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
  clientName = '',
}) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-transparent bg-opacity-50 z-90"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="fixed inset-0 z-100 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4">
          <div className="bg-card border border-border rounded-lg shadow-modal w-full max-w-md">
            {/* Header */}
            <div className="p-6">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-success/10 rounded-full flex items-center justify-center">
                  <Icon name="Play" size={24} className="text-success" />
                </div>
                <div>
                  <h2 className="text-lg font-semibold text-foreground">Activate Client</h2>
                  <p className="text-sm text-muted-foreground mt-1">
                    This action will activate the client and restore access.
                  </p>
                </div>
              </div>
            </div>
            {/* Content */}
            <div className="px-6 pb-6">
              <div className="bg-muted/50 border border-border rounded-lg p-4 mb-6">
                <p className="text-sm text-foreground">
                  Are you sure you want to activate <strong>{clientName}</strong>? 
                  This will restore their account, API keys, and all associated data.
                </p>
                <div className="mt-3 space-y-2">
                  <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                    <Icon name="Check" size={14} className="text-success" />
                    <span>API keys will be re-enabled</span>
                  </div>
                  <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                    <Icon name="Check" size={14} className="text-success" />
                    <span>Access to documentation will be restored</span>
                  </div>
                  <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                    <Icon name="Check" size={14} className="text-success" />
                    <span>Webhook configurations will be re-enabled</span>
                  </div>
                </div>
              </div>
              {/* Actions */}
              <div className="flex items-center justify-end space-x-3">
                <Button
                  variant="outline"
                  onClick={onClose}
                  disabled={isLoading}
                >
                  Cancel
                </Button>
                <Button
                  variant="success"
                  onClick={onConfirm}
                  loading={isLoading}
                  iconName="Play"
                >
                  Activate Client
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>,
    document.body
  );
};

export default ActivateConfirmModal;
